import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { OrganisationFetcher } from "./fetcher";

const ContactOrganisations = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Unternehmen</PageTitle>
          <Link to={`/contacts/organisations/create`}>
            <Button className="px-4 py-2 bg-blue-500 text-white rounded-md">+ Neues Unternehmen</Button>
          </Link>
        </div>
      </PageTitleContainer>
      <OrganisationFetcher searchQuery={searchQuery} setReload={setReload} reload={reload} />
    </div>
  );
};

export default ContactOrganisations;
